// extracted by mini-css-extract-plugin
export default {"login":"login_xvEeg","loginLeft":"loginLeft_DzFXz","footer":"footer_BdV9r"};